// TODO = Labels a panther key
export const HOMEPAGE_URL = '/#';
export const HOMEPAGE_LABEL = 'homepage_label';
export const CARBON_CREDIT_SERVICE_URL = '/';
export const CARBON_CREDIT_SERVICE_LABEL = 'carbon_credit_service_label';
export const CHECKOUT_LABEL = 'checkout_label';
export const INFORMATION_FORM_STORAGE = 'intakeInformationData';
